import React from 'react';
import classes from './GiftPostIntro.module.css';
import LiefImage from 'assets/images/liefIcons/lief-man@3x.png';

const giftPostIntro = (props) => {
  const bulletPoints = props.newPost
    ? [
        'Add as little or as much detail as you want!',
        'You can also add a note to the invite',
        'Gift the post to one or more people - or to a whole log.',
        'Your gift will show up in their Drafts. Then they can make the gifted post their own.',
        'You can also save a copy for yourself.',
      ]
    : [
        'Make any edits to this post and gift it to one or more people - or to a whole log.',
        'If there are contributions on your original post, they will not show up on your gift.',
        'Your gift will show up in their Drafts. Then they can make the gifted post their own.',
      ];
  return (
    <div className={classes.GiftPostIntroContainer}>
      <img src={LiefImage} alt="Gift-Post" />
      <h2>Create a post for someone else!</h2>
      <ul className={classes.BulletPoints}>
        {bulletPoints.map((bulletPoint, i) => (
          <li key={`bulletPoint-${i}`}>{bulletPoint}</li>
        ))}
      </ul>
      <p className={classes.Dismiss} onClick={props.dismiss}>
        Don’t show this again.
      </p>
    </div>
  );
};

export default giftPostIntro;
